/**
 * Signus Fluent UI themes — brand ramp centered on #1014f5.
 *
 * Both light and dark variants share the brand ramp; createLightTheme and
 * createDarkTheme derive the appropriate hover / pressed / selected tokens.
 */

import {
  BrandVariants,
  createDarkTheme,
  createLightTheme,
  Theme,
} from '@fluentui/react-components';

const signusBrand: BrandVariants = {
  10: '#010114',
  20: '#030438',
  30: '#05065c',
  40: '#080980',
  50: '#0a0ca4',
  60: '#0d10c8',
  70: '#0e12e0',
  80: '#1014f5', // primary
  90: '#2c30ff',
  100: '#5356ff',
  110: '#777aff',
  120: '#9698ff',
  130: '#b1b3ff',
  140: '#c9caff',
  150: '#dfe0ff',
  160: '#f0f0ff',
};

export const signusLightTheme: Theme = createLightTheme(signusBrand);
export const signusDarkTheme: Theme = createDarkTheme(signusBrand);
